import { useState } from 'react';
import { api } from 'app/api/client';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { TRootStackParamList } from 'app/types/navigation';

interface IAppointmentReportDownloadResponse {
  signed_url: string;
}

export const useAppointmentReportDownload = () => {
  const navigation = useNavigation<NativeStackNavigationProp<TRootStackParamList>>();
  const [isDownloading, setIsDownloading] = useState<string | null>(null);

  const downloadAndView = async (reportId: string) => {
    try {
      setIsDownloading(reportId);
      const data = await api.get<IAppointmentReportDownloadResponse>(
        `/patient/api/v1/appointment-reports/${reportId}/download`
      );
      navigation.navigate('PdfDocumentPage', { pdfUrl: data.signed_url });
    } finally {
      setIsDownloading(null);
    }
  };

  return { downloadAndView, isDownloading };
};
